import { cn } from '@nexelem/utils';

export type SkeletonProps = {
  className?: string;
  style?: React.CSSProperties;
};

export const Skeleton = ({ className, style }: SkeletonProps) => (
  <div
    className={cn('h-8 w-full animate-pulse rounded-xs bg-surface-state-neutral-light', className)}
    role="status"
    style={style}
  />
);
